import {BREADCRUMB_SELECT}  from "../actionTypes/index";


export const handleSlice =  (value) => async dispatch => {
  dispatch({ type: BREADCRUMB_SELECT, payload: value });
}
